import React, { useEffect, useState } from 'react'
import styles from './Index.module.css';
import { GoDotFill, GoHomeFill } from 'react-icons/go';
import { IoIosLogOut, IoIosSettings } from 'react-icons/io';
import { FaRegCircleUser } from 'react-icons/fa6';
import { MdAttachMoney, MdAutorenew, MdOutlineCancel } from "react-icons/md";
import { GrStorage } from "react-icons/gr";
import CloudStorageDashboard from './CloudStorageDashboard';
import SubscriptionInfo from './SubscriptionInfo'
import NavBar from './NavBar';
import { Redirect, Route, Switch } from "react-router";
import { useLocation, Link } from 'react-router-dom';
import { link } from 'fontawesome';
import { FaUser } from "react-icons/fa";
import UserInfo from './UserInfo';
import LicenseError from './LicenseError';

const SettingDashboard = ({ isValidLicence, setRefresh }) => {
    const location = useLocation();

    const getLinkClasses = (path) => {
        const isActive = location.pathname === path;
        return {
            display: "flex",
            gap: 2,
            cursor: "pointer",
            backgroundColor: isActive ? "#121432" : "",
            color: isActive ? "white" : "black",
            textDecoration: "none",
            height: "100%",
            justifyContent: "center",
            padding: "0px 6px",
            alignItems: "center",
        }
    };

    const navLink = [
        {
            name: "Users",
            icon: FaUser,
            size: 15,
            link: "/property-manager-dashboard/settings/users"
        },
        {
            name: "Subscriptions",
            icon: MdAttachMoney,
            size: 20,
            link: "/property-manager-dashboard/settings/subscription"
        },
        {
            name: "Cloud Storage",
            icon: GrStorage,
            size: 20,
            link: "/property-manager-dashboard/settings/storage"

        }
    ]

    return (
        <div className={styles.rightContainer}>
            <NavBar />
            <div style={{ flex: 1, width: "100%", padding: 10, minHeight: 0 }}>
                <div style={{
                    height: "100%",
                    width: "100%",
                    border: "0.5px solid #D3D3D3",
                    borderRadius: 10,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <div style={{
                        height: 50,
                        width: "100%",
                        backgroundColor: "#F8F9FA",
                        padding: "0px 5px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexShrink: 0,
                        marginBottom: 10
                    }}>
                        <div style={{ fontSize: 15, fontWeight: "bold" }}>Property Manager Settings</div>
                    </div>
                    <div style={{ width: "100%", height: 40, backgroundColor: "#F8F9FA", display: "flex", alignItems: "center", gap: 7, borderRadius: "", marginBottom: 15 }}>
                        {navLink.map((item, index) => (
                            <Link key={index} to={item.link} style={getLinkClasses(item.link)}>
                                <item.icon size={item.size} />
                                <div> {item.name}</div>
                            </Link>
                        )
                        )}

                    </div>

                    <div style={{
                        flex: 1,
                        width: "100%",
                        overflowY: "auto",
                        minHeight: 0,
                        padding: 8,
                    }}>
                        <Switch>
                            <Route
                                path="/property-manager-dashboard/settings/users"
                                render={() => {
                                    return (isValidLicence ? <UserInfo setRefresh={setRefresh} /> : <LicenseError />)
                                }}
                            />

                            <Route
                                path="/property-manager-dashboard/settings/subscription"
                                render={() => {
                                    return <SubscriptionInfo />
                                }}
                            />

                            <Route
                                path="/property-manager-dashboard/settings/storage"
                                render={() => {
                                    return (isValidLicence ? <CloudStorageDashboard /> : <LicenseError />)
                                }}
                            />
                        </Switch>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default SettingDashboard